import React from "react";
import FormCard from "../../formCard";
import useStyles from "./styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Typography } from '@material-ui/core';


const MensagemSucesso = (props) => {
  const { titulo, mensagem, onClick, hasError } = props;
  const classes = useStyles();
  return (
    <FormCard hasError={hasError} titulo={titulo}>
      <Grid style={{ padding: '35px 15px 5px 15px' }}>
        <Grid container spacing={2}>
          <Typography className={classes.mensagem}>
            {mensagem}
          </Typography>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              onClick={onClick}
            >
              Voltar a página inicial
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </FormCard>
  )
}

export default MensagemSucesso;
